// The editor tab set shared by trips and templates on both platforms (Doc 06/07).
// Tab id → label as a const map (not a bare union) so the ids drive both the
// `ListTab` type and each platform's rendered tab list — no parallel switch to
// keep in sync. Web renders them as URL segments; mobile as a route param.
export const LIST_TABS = { packing: "Packing", todos: "To Do", notes: "Notes" };
export const isListTab = (s) => s !== undefined && s in LIST_TABS;
//# sourceMappingURL=listTabs.js.map